// NOTE: hooks
import { useState } from 'react'
import useDataSetPwd from './useDataSetPwd'
import useDataResetPwd from './useDataResetPwd'
// NOTE: components
import ReactLoading from 'react-loading'
import { Tooltip } from 'react-tooltip'
import { PasswordInfo } from './InputInfo'
import Button from '../../components/ui/Button'
// NOTE: images
import { IoMdHelpCircleOutline } from 'react-icons/io'
import { BiShow, BiHide } from 'react-icons/bi'
import { TbAlertCircle as AlertIcon } from 'react-icons/tb'

const SetPwd = () => {
	const { loadingNewPassword, values, errors, touched, handleChange, handleSubmit, handleBlur } = useDataSetPwd()

	const { handleResetPwd, loadingResetPassword } = useDataResetPwd()

	const [seePassShow, setSeePassShow] = useState(false)
	const [seePassConfShow, setSeePassConfShow] = useState(false)
	const [passShow, setPassShow] = useState(false)

	return (
		<div>
			<PasswordInfo show={passShow} setShow={setPassShow} />

			<p className="text-dark mb-6 text-3xl font-semibold">Set new password</p>

			<form onSubmit={handleSubmit}>
				<div className="form-group mb-4 w-full">
					<label>Enter email</label>
					<input
						type="email"
						name="email"
						className="form-control cursor-not-allowed"
						value={values.email ?? ''}
						disabled={true}
						onBlur={handleBlur}
						required
					/>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.email && touched.email && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.email && touched.email && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.email}</span>
							</div>
						)}
					</div>
				</div>

				<div className="form-group mb-4" role="alert">
					<label>Enter password</label>
					<span
						onClick={() => setPassShow(true)}
						data-tooltip-id="password-tooltip"
						data-tooltip-content="Click for more information"
						data-tooltip-place="top"
					>
						<IoMdHelpCircleOutline className="flex-shrink-1 mb-2 ml-1 inline h-4 w-4" />
						<Tooltip id="password-tooltip" />
					</span>
					<div className="relative">
						<input
							type={seePassShow ? 'text' : 'password'}
							className={`form-control ${
								errors.password && touched.password ? 'input-error' : null
							}`}
							placeholder="Password"
							name="password"
							value={values.password}
							onChange={handleChange}
						/>

						<button
							type="button"
							className="absolute right-[8px] top-[7px] text-2xl"
							onClick={() => setSeePassShow((show) => !show)}
						>
							{seePassShow ? <BiShow /> : <BiHide />}
						</button>
					</div>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.password && touched.password && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.password && touched.password && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.password}</span>
							</div>
						)}
					</div>
				</div>

				<div className="form-group mb-4">
					<label>Confirm password</label>
					<div className="relative">
						<input
							type={seePassConfShow ? 'text' : 'password'}
							className={`form-control ${
								errors.confirmPwd && touched.confirmPwd ? 'input-error' : null
							}`}
							placeholder="Password"
							name="confirmPwd"
							value={values.confirmPwd}
							onChange={handleChange}
						/>
						<button
							type="button"
							className="absolute right-[8px] top-[7px] text-2xl"
							onClick={() => setSeePassConfShow((show) => !show)}
						>
							{seePassConfShow ? <BiShow /> : <BiHide />}
						</button>
					</div>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.confirmPwd && touched.confirmPwd && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.confirmPwd && touched.confirmPwd && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.confirmPwd}</span>
							</div>
						)}
					</div>
				</div>

				<Button
					type="submit"
					variant="primary"
					className="mt-4 w-full"
					loading={loadingNewPassword}
				>
					Set new password
				</Button>

				<div className="row mt-4 w-full">
					{!loadingResetPassword && (
						<a
							className="mt-6 font-semibold text-slate-600 underline hover:text-slate-600"
							onClick={() => handleResetPwd(values.email ?? '')}
						>
							Resend link
						</a>
					)}
					{loadingResetPassword && (
						<ReactLoading type={'bubbles'} color="#7a7a7a" width={'5rem'} delay={100} />
					)}
				</div>
			</form>
		</div>
	)
}
export default SetPwd
